/**
 * querySelector wrapper
 *
 * @param {string} selector Selector to query
 * @param {Element} [scope] Optional scope element for the selector
 */
export function qs(selector, scope) {
    return (scope || document).querySelector(selector);
}

/**
 * querySelectorAll wrapper
 *
 * @param {string} selector Selector to query
 * @param {Element} [scope] Optional scope element for the selector
 */
export function qsa(selector, scope) {
    return (scope || document).querySelectorAll(selector);
}

/**
 * addEventListener wrapper
 *
 * @param {Element|Window} target Target Element
 * @param {string} type Event name to bind to
 * @param {Function} callback Event callback
 * @param {boolean} [capture] Capture the event
 */
export function on(target, type, callback, capture) {
    target.addEventListener(type, callback, !!capture);
}

/**
 * Attach a handler to an event for all elements matching a selector.
 *
 * @param {Element} target Element which the event must bubble to
 * @param {string} selector Selector to match
 * @param {string} type Event name
 * @param {Function} handler Function called when the event bubbles to target
 *                           from an element matching selector
 * @param {boolean} [capture] Capture the event
 */
export function delegate(target, selector, type, handler, capture) {
    const dispatchEvent = event => {
        const targetElement = event.target;
        const potentialElements = target.querySelectorAll(selector);
        let i = potentialElements.length;

        while (i--) {
            if (potentialElements[i] === targetElement) {
                handler.call(targetElement, event);
                break;
            }
        }
    };

    on(target, type, dispatchEvent, !!capture);
}

const isTextSelected = input => {
    if (typeof input.selectionStart == "number") {
        return (
            input.selectionStart == 0 &&
            input.selectionEnd == input.value.length
        );
    } else if (typeof document.selection != "undefined") {
        input.focus();
        return document.selection.createRange().text == input.value;
    }
};

/**
 * Encode less-than and ampersand characters with entity codes to make user-
 * provided text safe to parse as HTML.
 *
 * @param {string} s String to escape
 *
 * @returns {string} String with unsafe characters escaped with entity codes
 */
export const escapeForHTML = s =>
    s.replace(/[&<]/g, c => (c === "&" ? "&amp;" : "&lt;"));

/**
 * Provides autofocus on next input field
 */
export function autoFocusNext(form, integersOnly = false) {
    let inputFields = form.querySelectorAll("input");

    for (let i = 0; i < inputFields.length; i++) {
        inputFields[i].addEventListener("keydown", function(e) {
            if (integersOnly) {
                if (!parseInt(e.key) && e.keyCode !== 8 && e.key !== "0") {
                    e.preventDefault();
                }
            }

            // shift + tab goes backwards
            if (e.shiftKey && e.keyCode === 9) {
                return inputFields[i - 1].focus();
            }

            // tab
            if (e.keyCode === 9 && !e.shiftKey) {
                inputFields[i + 1].focus();
			}

            // 8 is for backspace / delete
            if (e.keyCode === 8 && form.classList.contains("ssn-form")) {
                if (inputFields[i].value !== "") {
                    inputFields[i].value = "";
                } else {
                    inputFields[i - 1].focus();
                }
            }

            if (e.keyCode === 8 && form.classList.contains("dob-form")) {
                if (inputFields[i].value === "") {
                    inputFields[i - 1].focus();
                }
            }

            if (!isTextSelected(inputFields[i]) && inputFields[i].value.length === inputFields[i].maxLength) {
                if (inputFields[i + 1] && e.keyCode !== 8 && e.keyCode !== 16) {
                    inputFields[i + 1].focus();
                }
            }
        });
    }
}

/**
 * Provides validation for a radio form
 */

export function changeOpacity(inputFields) {
    for (let i = 0; i < inputFields.length; i++) {
        if (!inputFields[i].classList.contains("selected")) {
            inputFields[i].classList.add("fade");
        }
    }
}

export function removeSelected(inputFields) {
    for (let i = 0; i < inputFields.length; i++) {
        inputFields[i].classList.remove("selected");
    }
}

export function validateRadioForm(form) {
    let inputFields = form.querySelectorAll("input");

    for (let i = 0; i < inputFields.length; i++) {
        inputFields[i].addEventListener("click", function(e) {
            if (e.srcElement.classList.contains("fade")) {
                inputFields[i].classList.remove("fade");
            }
            removeSelected(inputFields);
            changeOpacity(inputFields);
            e.srcElement.classList.add("selected");
            form.querySelector(".button").classList.remove("disabled");
            form.querySelector(".warning").classList.add("hide");
        });
    }
}
